/**
 * Shared progress / busy checks for Tasks list and Translation detail.
 */

export function mergeProgress(...values: (number | null | undefined)[]): number {
  if (values.some((v) => v === -1)) return -1;
  return Math.max(0, ...values.map((v) => v ?? 0));
}

function pipelineBusy(v: number): boolean {
  return v > 0 && v < 100;
}

export function isTaskBusy(
  progress: {
    text_generation_progress?: number | null;
    translation_progress?: number | null;
    speech_generation_progress?: number | null;
  },
  live?: { transcript?: number; translation?: number; speech?: number },
  jobStatus?: string | null
): boolean {
  const ts = mergeProgress(progress.text_generation_progress, live?.transcript);
  const tr = mergeProgress(progress.translation_progress, live?.translation);
  const sp = mergeProgress(progress.speech_generation_progress, live?.speech);
  if (pipelineBusy(ts) || pipelineBusy(tr) || pipelineBusy(sp)) return true;
  if (jobStatus === "running" || jobStatus === "queued") return true;
  return false;
}
